<template>
  <div class="contact">
    <div class="poster-holder">
      <img src="static/img/eu-small.png" width="100%">
    </div>

    <div class="projects-container">
      <div class="project-content">
        <p class="project-desc" v-if="lang !== 'pl'">
          Bioseco S.A. realizes the project co-financed by European Funds.<br><br>
          <b>Project title:</b><br>
          Realization of R&D works leading to the implementation of a new solution - MULTIREJESTRATOR PLUS for
          monitoring and control of the power system in terms of operational efficiency, the life span extending and
          optimizing the impact on the
          surrounding wind farms.<br><br>
          Summary:<br>
          The aim of the project is to carry out R&D works leading to the
          development of a radio and video prototype system that will improve the efficiency and performance of wind
          turbines, which will affect the growth of innovation in the national electricity sector. The project will be
          implemented by a qualified project team in 4 research tasks, the aim of which will be to design a complete
          vision system that allows the prediction of bird traffic near wind farms. The project will end with the
          creation
          of technical documentation enabling the implementation of MULTIREJESTRATOR PLUS technology on the market. It
          is
          planned to cover the results of R&D works with patent protection on the Polish, British and then European
          markets.<br>MULTIREJESTRATOR PLUS will ensure uninterrupted or rarely interrupted work of wind farms, through
          the active protection of valuable bird species.<br><br>Project value:<br>4 109 660,41<br><br>Amount of
          founding
          from UE:<br>3 021 687,62
        </p>
        <p class="project-desc" v-if="lang === 'pl'">
          Bioseco S.A. realizuje projekt dofinansowany z Funduszy Europejskich.<br><br>
          Tytuł projektu:<br>
          Realizacja prac B+R, prowadzących do wdrożenia nowego rozwiązania - MULTIREJESTRATOR PLUS dla monitorowania i
          kontroli systemu elektroenergetycznego pod kątem efektywności eksploatacji, wydłużenia czasu życia i
          optymalizacji oddziaływania na otoczenie farm wiatrowych.
          <br><br>
          Cel projektu:<br>
          Celem projektu jest przeprowadzenie prac B+R prowadzących do opracowania prototypu systemu radiowo wizyjnego,
          który pozwoli podnieść sprawność i wydajność pracy turbin wiatrowych.<br><br>
          Wartosć projektu: <br>4 109 660,41PLN<br><br>
          Dofinansowanie projektu z UE: <br>3 021 687.62PLN<br>
        </p>
      </div>

      <div class="project-content">
        <p class="project-desc" v-if="lang !== 'pl'">
          <b>Project title:</b><br>
          Carrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING
          SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals
          <br><br>
          Summary:<br>
          The aim of the project is to carry out R&D works enabling the development of a prototype of the new AIRPORT
          FAUNA MONITORING SYSTEM (AFMS - monitoring system around the airport for the detection of land mammal
          avifauna).
          <br><br>
          Project value: <br>3 493 437,50PLN<br><br>
          Amount of founding from UE: <br>2 632 075.00PLN<br>
        </p>
        <p class="project-desc" v-if="lang === 'pl'">
          Tytuł projektu:<br>
          Przeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT
          FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.
          <br><br>
          Cel projektu:<br>
          Celem projektu jest przeprowadzenie prac B+R pozwalających na opracowanie prototypu nowego systemu AIRPORT
          FAUNA MONITORING SYSTEM (AFMS - system monitoringu okolic portu lotniczego do detekcji awifauny ssaków
          lądowych).<br><br>
          Wartość projektu: <br>3 493 437,50PLN<br><br>
          Dofinansowanie projektu z UE: <br>2 632 075.00PLN<br>
        </p>
      </div>

      <div class="project-content">
        <p class="project-desc" v-if="lang !== 'pl'">
          04.2016-05.2019 Bioseco SP. z o.o. realized project called “Bioseco” within the Operational Programme Smart Growth 2014-2020, Priority 1, Measure 1.3.,<br/>
          Sub- measure 1.3.1 - Support for R&D projects at the ‘pre-seed’ stage by proof of concept funds – Bridge Alfa<br/><br/>
          The aim of the Project was to design, manufacture and implement to the market an innovative tool supporting the development of energy and airport investments and the processes of conducting the environmental assessment.
          <br/><br/>
          Project Value : 3.000.000 PLN<br/>
          EU cofinancing: 2.400.000 PLN
        </p>
        <p class="project-desc" v-if="lang === 'pl'">
          W okresie 04.2016-05.2019 Bioseco S.A. realizowała projekt pod tytułem „Bioseco” w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020, Priorytet 1, Działanie 1.3,<br/>
          Poddziałanie 1.3.1 – Wsparcie Projektów Badawczo-Rozwojowych w fazie preseed  przez fundusze typu Proof of Concept – Bridge Alfa.<br/><br/>
          Celem Projektu było zaprojektowanie, wytworzenie oraz wdrożenie na rynek innowacyjnego urządzenia wspomagającego rozwój inwestycji energetycznych i lotniskowych oraz procesy prowadzenia badań środowiskowych.
          <br/><br/>
          Wartość projektu: 3.000.000 złotych<br/>
          Wartość dofinansowania UE: 2.400.000 złotych
        </p>
      </div>
    </div>

    <div class="right-hexagons">
      <div class="bg-hexagon"></div>
      <div class="bg-hexagon"></div>
      <div class="bg-hexagon"></div>
      <div class="bg-hexagon"></div>
    </div>
    <div class="more-link">
      <router-link class="more-about-us" active-class="active" to="/about"><span>{{$t('component.moreAboutUs')}}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';

  export default {
    name: 'projects',
    data() {
      return {}
    },
    mounted: function () {

    },
    methods: {
      menuToggle: () => {
        store.commit('TOGGLE_MENU');
      },
      showModal: function () {
        store.commit('SET_MODAL', {visible: true, questionName: ''});
      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      }
    }
  }
</script>

<style>
  .poster-holder {
    width: 100%;
    max-width: 600px;
    margin: 40px auto 0px auto;
  }

  .project-desc {
    width: 90%;
    max-width: 600px;
    margin: 40px auto 0px auto;
    padding: 10px;
  }

  .projects-container {
    margin-top: 20px;
    padding-bottom: 120px;
  }

  .project-content {
    margin-top: 20px;
    border-bottom:1px solid #ccc;
    padding-bottom: 20px;

  }

  .more-link {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background-color: rgba(255, 255, 255, 0.5);
  }
</style>



// WEBPACK FOOTER //
// CofinancedFromEU.vue?0d5d0104